import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { Option, Select } from 'carbon-react/lib/components/select';

import { IncreaseDecreaseRepeating, RepeatingPattern } from '../../../types';
import { RepeatingMethodState } from '../types';
import styles from '../repeating-method.scss';

interface IncreaseDecreaseTypeProps {
  disabled?: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  repeatPattern: RepeatingMethodState['repeat_pattern'];
  value: IncreaseDecreaseRepeating | null;
}

export const IncreaseDecreaseType = ({ disabled, onChange, repeatPattern, value }: IncreaseDecreaseTypeProps) => {
  const intl = useIntl();

  const repeatPatternText = useMemo(
    () => ({
      [RepeatingPattern.daily]: intl.formatMessage({ id: 'common.repeat_daily', defaultMessage: 'Daily' }),
      [RepeatingPattern.weekly]: intl.formatMessage({ id: 'common.repeat_weekly', defaultMessage: 'Weekly' }),
      [RepeatingPattern.monthly]: intl.formatMessage({
        id: 'common.repeat_monthly',
        defaultMessage: 'Monthly'
      }),
      [RepeatingPattern.quarterly]: intl.formatMessage({
        id: 'common.repeat_quarterly',
        defaultMessage: 'Quarterly'
      }),
      [RepeatingPattern.annually]: intl.formatMessage({
        id: 'common.repeat_annually',
        defaultMessage: 'Annually'
      })
    }),
    [intl]
  );

  return (
    <div className={styles.carbonActionItem}>
      <Select
        autoComplete="off"
        disabled={disabled}
        onChange={onChange}
        value={value || ''}
        label={intl.formatMessage(
          { id: 'predict.value_increase_decrease', defaultMessage: '{period} increase/decrease' },
          { period: repeatPatternText[repeatPattern] }
        )}
        size="large"
      >
        <Option
          value={IncreaseDecreaseRepeating.never}
          text={intl.formatMessage({ id: 'common.never', defaultMessage: 'Never' })}
        />
        <Option
          value={IncreaseDecreaseRepeating.increaseDecreaseByPercentage}
          text={intl.formatMessage({
            id: 'predict.increase_decrease_percentage',
            defaultMessage: 'Increase/decrease by %'
          })}
        />
        <Option
          value={IncreaseDecreaseRepeating.increaseDecreaseByAmount}
          text={intl.formatMessage({ id: 'predict.increase_decrease_by', defaultMessage: 'Increase/decrease by' })}
        />
      </Select>
    </div>
  );
};
